import { CrownOutlined } from '@ant-design/icons';

const Crown = () => (
	<span
		aria-hidden
		style={{
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexShrink: 0,
			width: 24,
			height: 24,
			boxSizing: 'border-box',
			borderRadius: '50%',
			color: 'var(--ant-color-warning-text)',
			background: 'var(--ant-color-warning-bg)',
			border: '1px solid var(--ant-color-warning-border)',
			lineHeight: 1,
		}}
	>
		<CrownOutlined style={{ fontSize: 14 }} />
	</span>
);

export default Crown;
